import { Row } from 'react-bootstrap';
import { Html } from '../Components/Html';
export default function Title({ data: { props: { color }, html } }: { data: any }) {
    return <Row className='m-0 p-0' style={{ background: color }}>
        <Html html={html} className={`container`} />
    </Row>
}